<template>
  <div class="cmi-resource-view">
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <h3 class="header">AUDIO MESSAGES</h3>
        </div>
      </div>
      <div class="panel-body">
        <div class="panel panel-info cmi-search-header-panel">
          <div class="row cmi-search-wrapper">
            <div class="col-md-8 col-md-offset-2">
              <div class="cmi-search-header">
                <div class="row cmi-search-header-row">
                  <div class="col-md-4 header-left">
                    <span>Filter by date</span>
                  </div>
                  <div class="col-md-6 header-middle">
                    <select
                      id="filterLabel"
                      name="filterLabel"
                      @change="getFormDataByLabel"
                      v-model.trim="res_FilterLabel"
                      class="form-control"
                    >
                      <option></option>
                      <option
                        v-for="item in resourceLabels"
                        v-bind:value="item.label"
                        :key="item.label"
                        >{{ item.label }}</option
                      >
                    </select>
                  </div>
                  <div class="col-md-2 header-right">
                    <span
                      v-if="aniLabelsLoading"
                      class="fa fa-spinner fa-spin fa-3x fa-fw"
                    ></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row clearfix-res">
        <transition-group
          name="animate-resource"
          @afterEnter="itemAfterEnter"
          enter-active-class="animated lightSpeedIn"
          leave-active-class="animated zoomOut"
        >
          <div
            v-for="item in resourceItems"
            v-bind:key="item.pkey"
            class="col-sm-6"
          >
            <div class="widget cmi-widget">
              <div class="sermon-widget">
                <div class="sermon-img">
                  <img
                    v-bind:src="item.res_FileThumbnailPath"
                    alt="audio cover image"
                  />
                  <span>
                    <i class="fa fa-calendar-o"></i>
                    {{ item.res_MessageLabel }}
                  </span>
                  <h3>
                    <a href="#" title>{{ item.res_Person }}</a>
                  </h3>
                </div>
                <div class="sermon-detail">
                  <p class="sermon-description">
                    <span class="sermon-title">Date: </span>
                    <span class="sermon-text">{{ item.res_MessageDate }}</span>
                  </p>
                  <p class="sermon-description">
                    <span class="sermon-title">Event: </span>
                    <span class="sermon-text">{{ item.res_Event }}</span>
                  </p>
                  <p class="sermon-description">
                    <span class="sermon-title">Title: </span>
                    <span class="sermon-text">{{ item.res_MessageTitle }}</span>
                  </p>
                  <p class="sermon-description">
                    <span class="sermon-title">Series: </span>
                    <span class="sermon-text">{{ item.res_MessageGenre }}</span>
                  </p>

                  <p class="sermon-description">
                    <span class="sermon-title">Audio file name: </span>
                    <span class="sermon-text">{{ item.res_FileName }}</span>
                  </p>
                  <p
                    v-if="item.res_MessageCommentary"
                    class="sermon-commentary"
                  >
                    <span class="sermon-commentary-title">Commentary: </span>
                    {{ item.res_FileName }}
                  </p>
                  <div class="cmi-sermon-player-wrapper">
                    <audio
                      class="cmi-audio-player"
                      v-bind:src="item.res_FilePath"
                    ></audio>
                  </div>
                  <ul class="sermon-media">
                    <li>
                      <a
                        v-bind:href="item.res_FileDownloadLink"
                        title="download audio"
                      >
                        <i class="fa fa-download"></i>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </transition-group>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
export default {
  props: {
    baseUrl: { type: String }
  },
  data() {
    return {
      aniLabelsLoading: false,
      resourceLabels: [],
      resourceItems: [],
      res_FilterLabel: ""
    };
  },
  methods: {
    getResourceLabels: async function() {
      this.aniLabelsLoading = true;
      let rData = null;
      let actionUrl = `${this.baseUrl}GetResourceLabels`;
      try {
        ({ data: rData } = await axios.get(actionUrl));
      } catch (error) {
        this.aniLabelsLoading = false;
        throw error;
      }
      if (rData) {
        Object.assign(this.resourceLabels, rData);
        if (this.resourceLabels.length > 0) {
          this.res_FilterLabel = this.resourceLabels[0].label;
        }
        await this.getFormDataByLabel();
      }
      this.aniLabelsLoading = false;
    },

    getFormDataByLabel: async function() {
      if (!this.res_FilterLabel) {
        this.resourceItems = [];
        return;
      }
      this.aniLabelsLoading = true;
      const config = {
        params: { dateLabel: this.res_FilterLabel }
      };
      let rData = null;
      let actionUrl = `${this.baseUrl}GetResourceDataByLabel`;
      try {
        ({ data: rData } = await axios.get(actionUrl, config));
      } catch (error) {
        this.aniLabelsLoading = false;
        throw error;
      }
      if (rData) {
        this.resourceItems = rData;
      }
      this.aniLabelsLoading = false;
    },
    itemAfterEnter: function(el) {
      window
        .$(el)
        .find(".cmi-audio-player")
        .mediaelementplayer();
    }
  },
  computed: {
    showContent: function() {
      if (this.resourceItems.length > 0) {
        return true;
      }
      return false;
    }
  },
  async mounted() {
    await this.getResourceLabels();
  }
};
</script>
